import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=a5e3b1fc&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=a5e3b1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e3b1fc",
  null
  
)

export default component.exports